import { useCallback, useEffect } from 'react';
import { Canvas } from 'fabric';

import { Tool, EraserProps } from '../draw-canvas.constants';
import { ToolBarTool } from './toolbar.style';
import IconEraser from 'approot/shared/inline-svg/activity-builder/icon-eraser';
import { useDrawCanvasContext } from '../draw-canvas.context';
import ToolbarItem from './toolbar-item';

type Props = {
  canvas?: Canvas | null;
  eraserTool: EraserProps;
};

const ToolbarItemEraser = ({ eraserTool, canvas }: Props) => {
  const { toolSet, setEraserDrawing } = useDrawCanvasContext();

  const updateEraserSettings = useCallback(
    (canvas: Canvas | null | undefined) => {
      if (canvas) {
        canvas.discardActiveObject();
        canvas.renderAll();

        setEraserDrawing(canvas, eraserTool);
      }
    },
    [eraserTool, setEraserDrawing]
  );

  useEffect(() => {
    if (canvas && toolSet?.tool === Tool.Eraser) {
      updateEraserSettings(canvas);
    }
  }, [eraserTool, canvas, toolSet?.tool, updateEraserSettings]);

  return (
    <ToolbarItem hoverText="Eraser">
      <ToolBarTool
        data-selector="toolbar-eraser"
        $isActive={toolSet?.tool === Tool.Eraser}
        onClick={() => updateEraserSettings(canvas)}
      >
        <IconEraser width={24} height={24} />
      </ToolBarTool>
    </ToolbarItem>
  );
};

export default ToolbarItemEraser;
